import React, { useEffect, useState } from "react";
import {
  Button,
  Layout,
  Row,
  Col,
  Typography,
  Form,
  Input,
  ColorPicker,
  Tag,
  message,
  Popconfirm,
  Breadcrumb
} from "antd";
import { useParams , useNavigate } from "react-router-dom";
import { useAuth } from "../../utils/Auth/AuthWrapper";
import { category_create, category_update , get_category , get_all_category } from "../../services/category";
import "../createTaskCategory/styles/index.less"
import { useTranslation } from "react-i18next";

const { Content } = Layout;
const { Title } = Typography;

type Props = {};

interface DataType {
  key: string;
  category_id: string;
  name: string;
  description: string;
  colortag: string;
  created_date: any;
}

const CreateTaskCategory = (props: Props) => {
  const navigate = useNavigate();
  const params = useParams();
  const [form] = Form.useForm();
  const auth = useAuth();
  const { t } = useTranslation();
  const [editcategory , setEditCategory] = useState<DataType[]>([]);
  const [existingCategories, setExistingCategories] = useState<string[]>([]);
  const [formData, setFormData] = useState({
    name: '',
    detail: '',
    colortag: '#1677ff',
  });

  const handleColorChangeTag = (color: { hex?: string }) => {
    let hexColorTitle: string;
    if (typeof color === 'string') {
      hexColorTitle = color;
    } else {
      hexColorTitle = color.hex || '';
    }
    setFormData({ ...formData, colortag: hexColorTitle });
    form.setFieldsValue({ colortag: hexColorTitle });
  };

  const onFinish = async (values: any) => {
    try {
      if (params.action === "new") {
        const res = await category_create({
          user_id: auth.user.user_id,
          name: values.name,
          colortag: values.colortag,
          description: form.getFieldValue("description"),
        });
  
        if (res.status === "success") {
          message.success(t("Category created successfully"));
          form.resetFields();
          navigate("/task/category");
        }
      } else if (params.action === "edit") {
        const res = await category_update({
          category_id: params.category_id,
          user_id: auth.user.user_id,
          name: values.name,
          colortag: values.colortag,
          description: form.getFieldValue("description"),
        });
        
        if (res.status === "success") {
          message.success(t("Category updated successfully"));
          form.resetFields();
          navigate("/task/category");
        }
      }
    } catch (e) {
      console.error(e);
      message.success(t("An error occurred. Please try again"));
    }
  };

  useEffect(() => {
    if (params.action == "edit") {
      getTaskCategory();
    }
    getAllCategories();
  }, []);


  const getAllCategories = async () => {
    try {
      const res = await get_all_category(); 
      if (!res.result || !Array.isArray(res.result)) {
        console.error("Invalid response format:", res);
        return;
      }
      const categoryNames = res.result.map((item: any) => item.name.toLowerCase());
      setExistingCategories(categoryNames);
    } catch (e) {
      console.error("Error fetching categories:", e);
    }
  };


  const validateCategoryName = (_: any, value: string) => {
    if (!value || value.trim() === "") {
      return Promise.reject(t("Please enter a task category name"));
    }
    if (params.action === "new" && existingCategories.includes(value.trim().toLowerCase())) {
      return Promise.reject(t("Category name already exists"));
    }
    return Promise.resolve();
  };


  const getTaskCategory = async () => {
    try {
      const res = await get_category({ category_id: params.category_id });
      if (!res.result || !Array.isArray(res.result)) {
        throw new Error("Invalid response format: result is not an array");
      }
      const matchedData = res.result.find(
        (item: any) => item.category_id === params.category_id
      );
      if (!matchedData) {
        throw new Error(`Category with ID ${params.category_id} not found`);
      }
      const cleanedDescription = matchedData.description?.replace(/^"|"$/g, "") || "";
      form.setFieldsValue({
        name: matchedData.name || "",
        description: cleanedDescription,
        colortag: matchedData.colortag || "",
      });
      setEditCategory(res.result);
    } catch (e) {
      console.error("Error fetching category:", message || e);
      message.error("Failed to fetch category. Please try again later.");
    }
  };
  

  return (
    <Layout>
      <Content className="taskscategory-layout">
        {/* head */}
        <div>
          <Row justify="space-between" align="middle">
          <Breadcrumb
              separator=">"
              items={[
                {
                  title: (
                    <span style={{ fontWeight: "bold" }}>
                      {params.action == "new" ? t("Add Task Category") : t("Edit Task Category")}
                    </span>
                  ),
                },
              ]}
            />
            <h2 style={{ fontSize: "32px", color: "black", display: "contents" }}></h2>
          </Row>
          <hr />
        </div>
      



      {/* form */}
      <Content style={{margin:"20px 0px 0px 0px"}}>
        <Form form={form} layout="vertical" onFinish={onFinish}>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                label={t("name category")}
                name="name"
                rules={[
                  { required: true },
                  { validator: validateCategoryName },
                ]}
              >
                <Input placeholder={t("Enter category name")} />
              </Form.Item>
            </Col>
            {/* <Col span={4}>
              <Form.Item
                name="colortag"
                label="Color Tag"
                rules={[{ required: true, message: 'Please select a color!' }]}
              >
                <Input
                  value={formData.colortag}
                  onChange={(e) => handleColorChangeTag({ hex: e.target.value })}
                  placeholder="Enter color"
                />
              </Form.Item>
            </Col> */}
            {/* <Col span={2}>
              <Form.Item
                name="colortag"
                label="Color"
              >
                <ColorPicker
                  value={formData.colortag}
                  onChange={(color, hex) => handleColorChangeTag({ hex })}
                  format="hex"
                />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item label="Example">
                <Tag color={formData.colortag}>Example</Tag>
              </Form.Item>
            </Col> */}
          </Row>
          <Row>
            <Col span={24}>
              <Form.Item label={t("detail category")} name="description">
                <Input.TextArea placeholder={t("Enter category details")} rows={4} />
              </Form.Item>
            </Col>
          </Row>
          <Row justify="end">
            <Col>
            <Popconfirm
                title={t("Alert title")}
                description={t("Alert detail")}
                okText={t("confirm")}
                cancelText={t("cancel")}
                onConfirm={() => navigate('/task/category')}
              >
                <Button style={{ marginRight: '10px' }}>{t("cancel")}</Button>
              </Popconfirm>

              <Popconfirm
                title={params.action === "new" ? t("Alert confirm create title") : t("Alert confirm update title")}
                description={params.action === "new" ? t("Alert confirm create detail") : t("Alert confirm update detail")}
                onConfirm={() => form.submit()}
                okText={t("yes")}
                cancelText={t("no")}
              >
                <Button type="primary" htmlType="button">
                  {params.action === "new" ? t("create") : t("update")}
                </Button>
              </Popconfirm>
            </Col>
          </Row>
        </Form>
      </Content>
      </Content>
    </Layout>
  );
};

export default CreateTaskCategory;
